interface PageIntroProps {
  readonly body: string;
  readonly eyebrow: string;
  readonly title: string;
}

export function PageIntro({ body, eyebrow, title }: PageIntroProps) {
  return (
    <header className="page-intro">
      <div className="page-intro__copy">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="page-intro__body">{body}</p>
      </div>
      <div aria-hidden="true" className="page-intro__visual">
        <span className="page-intro__sun" />
        <span className="page-intro__ridge page-intro__ridge--far" />
        <span className="page-intro__ridge page-intro__ridge--near" />
        <span className="page-intro__grid" />
      </div>
    </header>
  );
}
